import { ReportsPage } from './../../Raporlars/reports/reports';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';



@Component({
  selector: 'page-tanım-ana',
  templateUrl: 'tanım-ana.html',
})
export class TanımAnaPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
  
  }
  RaporSayfasi() {
    this.navCtrl.push(ReportsPage)
  }

}



// WEBPACK FOOTER //
// ./src/pages/Tanımlamalar/tanım-ana/tanım-ana.ts